import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { MessageEventMessage } from '../connectivity';
import { MessageInterface, ChatStatus, ContentMessageType, MessageStatus } from '../models/chat';

@Injectable({
  providedIn: 'root'
})
export class MessageCommunicationService {

  private messageEventSubject = new Subject<MessageEventMessage>();
  public messageEvent$: Observable<MessageEventMessage> = this.messageEventSubject.asObservable();

  constructor() { }

  get messageEvents(): Observable<MessageEventMessage> {
    return this.messageEvent$;
  }

  /**
   * Emit a message event message to subscribers
   * @param message The message event message to emit
   */
  emitMessageEvent(message: MessageEventMessage): void {
    this.messageEventSubject.next(message);
  }


  convertMessageEventMessageToMessage(
    event: MessageEventMessage
  ): MessageInterface {
    const parseDate = (dateStr?: string | null): Date | undefined => {
      return dateStr ? new Date(dateStr) : undefined;
    };

    // Map string to ChatStatus enum
    const mapChatStatus = (status: string): ChatStatus => {
      switch (status.toLowerCase()) {
        case 'agent':
          return 'agent';
        case 'user':
          return 'user';
        case 'bot':
          return 'bot';
        default:
          return 'user'; // fallback
      }
    };

    // Map string to ContentMessageType enum
    const mapContentMessageType = (type: string): ContentMessageType => {
      switch (String(type || '').toLowerCase()) {
        case 'text':
          return ContentMessageType.Text;
        case 'image':
          return ContentMessageType.Image;
        case 'video':
          return ContentMessageType.Video;
        case 'audio':
          return ContentMessageType.Audio;
        case 'document':
          return ContentMessageType.Document;
        default:
          return ContentMessageType.Unsupported;
      }
    };

    // Map string to MessageStatus enum
    const mapMessageStatus = (status: string): MessageStatus => {
      switch (String(status || '').toLowerCase()) {
        case 'pending':
          return 'Pending';
        case 'sent':
          return 'Sent';
        case 'delivered':
          return 'Delivered';
        case 'read':
          return 'Read';
        case 'failed':
          return 'Failed';
        default:
          return 'Pending';
      }
    };

    const messageType = event.message_type ?? event.messageType ?? '';
    const contentTranslated = event.content_translated ?? event.contentTranslated ?? undefined;
    const datePending = event.date_pending ?? event.datePending;
    const dateSent = event.date_sent ?? event.dateSent;
    const dateDelivered = event.date_delivered ?? event.dateDelivered;
    const dateRead = event.date_read ?? event.dateRead;
    const agentId = event.agent_id ?? event.agentId ?? null;
    const campaignId = event.campaign_id ?? event.campaignId ?? null;
    const workspaceId = event.workspace_id ?? event.workspaceId ?? null;
    const targetScope = event.target_scope ?? event.targetScope ?? null;

    return {
      messageId: event.message_id ?? event.messageId,
      conversationId: event.conversation_id ?? event.conversationId ?? '',
      type: mapChatStatus(event.type),
      messageType: mapContentMessageType(messageType),
      content: event.content,
      contentTranslated,
      datePending: parseDate(datePending),
      dateSent: parseDate(dateSent),
      dateDelivered: parseDate(dateDelivered),
      dateRead: parseDate(dateRead),
      status: mapMessageStatus(event.status),
      timestamp: parseDate(event.timestamp),
      handlerType: agentId ?? undefined,
      agentId,
      campaignId,
      workspaceId,
      targetScope,
    };
  }

}




